import Navbar from "@/components/Navbar";
import CinematicHeroEn from "@/components/landing/en/CinematicHeroEn";
import SaCagnotteEn from "@/components/landing/en/SaCagnotteEn";
import NewHowItWorksSectionEn from "@/components/landing/en/NewHowItWorksSectionEn";
import InteractiveTimelineEn from "@/components/landing/en/InteractiveTimelineEn";
import TrustSectionEn from "@/components/landing/en/TrustSectionEn";
import BirthDateCalculatorEn from "@/components/BirthDateCalculatorEn";
import EmotionalFooterEn from "@/components/landing/en/EmotionalFooterEn";

const New4LandingEn = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="home" />
      <CinematicHeroEn />
      <SaCagnotteEn />
      <NewHowItWorksSectionEn />
      <InteractiveTimelineEn />
      <TrustSectionEn />
      <BirthDateCalculatorEn />
      <EmotionalFooterEn />
    </div>
  );
};

export default New4LandingEn;
